import React from 'react';
import {withStyles} from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import { BusinessClassPlane } from './Planes/BusinessClassPlane';
import { EconomyClassPlane } from './Planes/EconomyClassPlane';
import { FirstClassPlane } from './Planes/FirstClassPlane';
import { UpgradeButton } from './UpgradeBtn';

const styles = (theme) => ({
    containerWrap: {
        position: 'relative'
    },
    container: {
        marginTop: 65,
        marginBottom: 15,
        marginLeft: 10,
        width: 200,
        height: 140,
        borderRadius: 6,
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.subscriptionColors.secondary
    },
    text: {
        marginTop: 40,
        height: 40,
        fontFamily: 'Rubik',
        fontSize: 14,
        marginLeft: 6,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#aaa2b8',
    },
    proText: {
        fontWeight: '500',
        color: '#21212d'
    },
    btn: {
        position: 'absolute',
        bottom: 20,
        backgroundColor: theme.subscriptionColors.main
    }
})

const UpgradePlanView = (props) => {
    const {classes, subscriptionType, onClick, t } = props

    const Title = <span autoCapitalize={false} className={classes.text}>Upgrade to <span className={classes.proText}>PRO</span> for <br/> more features</span>

    const Plane = getPlane(subscriptionType)

    return (
        <div data-intrcm-id="UpgradePlan_my6rtqnx" className={classes.containerWrap}>
            {Plane}
            <div data-intrcm-id="UpgradePlan_tzp80yta" className={classes.container}>
                {Title}
                <UpgradeButton translations={{upgrade: t("Upgrade")}} containerClasses={classes.btn} onClick={onClick}/>
            </div>
        </div>
    )
}

export const UpgradePlan = compose(
    withStyles(styles, {withTheme: true}),
    withTranslation('admin'),
)(UpgradePlanView)

const getPlane = (subscriptionType) => {
    switch (subscriptionType) {
        case 0:
            return <EconomyClassPlane/> 
        case 1:
            return <BusinessClassPlane />
        case 2:
            return <FirstClassPlane />
        default:
            return <EconomyClassPlane />
    }
}